export enum PaymentMode {
  WesternUnion = "Western Union",
  ApplicationFeeWaiverCode = "Application Fee Waiver Code",
  Other = "Other",
}
